/**
 * Код бренда по умолчанию.
 *
 * Тот же, что `BASE_BRAND` в `src/branding/pack.py` и `DEFAULT 'rumb'` у
 * `site_domain.brand_id` (миграция 284). Витрине он нужен ровно там, где пак не
 * доехал или не разобрался: ИМЯ бренда в этом случае берётся из каталога
 * переводов (`brand.name`), а код взять неоткуда — он не текст, а часть имени
 * скачиваемого файла.
 *
 * Отдельный модуль-лист, без зависимостей: константу читает и `exportPlate.ts`
 * (чистый слой, без React), и хуки бренда.
 */
export const BASE_BRAND_ID = 'rumb'
